export const LineCount = (count) => {
    var newCount = 12 / count;
    return parseInt(newCount);
}